import { render, staticRenderFns } from "./newDataClientDBG.vue?vue&type=template&id=7a968174&scoped=true"
import script from "./newDataClientDBG.vue?vue&type=script&lang=js"
export * from "./newDataClientDBG.vue?vue&type=script&lang=js"
import style0 from "./newDataClientDBG.vue?vue&type=style&index=0&id=7a968174&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a968174",
  null
  
)

export default component.exports